// onboarding-etapa-textos.js — Quién eres le habla a cada etapa con sus palabras (#1850).
// Las preguntas y los campos son los mismos para todos (el back no cambia); cambia cómo se
// preguntan y qué responde la tarjeta de horas. Sin «cansado» ni «guardia» (0 usos en 1.344
// mensajes de médicos) y sin prometer horas ahorradas (no está medido, probidad).

const POR_ETAPA = {
  interno: {
    donde: "Dónde haces tu internado",
    dondePh: "Ej: Medicina interna, Hospital del Salvador",
    carga: "Cuánto te toma escribir evoluciones e ingresos por turno",
    turnos: "Cuántos turnos de internado haces a la semana?",
    reaccion: "En el internado es donde más se escribe. Saquemos tu cuenta.",
    equipo: "En tu servicio, quién más está en el turno?",
  },
  estudiante: {
    donde: "Dónde haces tus prácticas",
    dondePh: "Ej: Medicina interna, Hospital Clínico U. de Chile",
    carga: "Cuánto te toma escribir tus evoluciones por turno",
    turnos: "Cuántos turnos haces a la semana?",
    reaccion: "Vas a llegar al internado con el turno ordenado.",
  },
  becado: {
    donde: "Dónde haces tu beca",
    dondePh: "Ej: Medicina interna, Hospital Sótero del Río",
    carga: "Cuánto te toma documentar por turno",
    turnos: "Cuántos turnos haces a la semana (beca y extras)?",
    reaccion: "En la beca el papeleo se come el turno. Saquemos tu cuenta.",
  },
  medico_general: {
    donde: "Dónde trabajas",
    dondePh: "Ej: Urgencia, Hospital de Curicó",
    carga: "Cuánto te toma documentar por turno",
    turnos: "Cuántos turnos haces a la semana?",
    reaccion: "Ingresos, evoluciones, epicrisis: saquemos cuánto se te va.",
  },
  especialista: {
    donde: "Dónde trabajas",
    dondePh: "Ej: UCI, Clínica Las Condes",
    carga: "Cuánto te toma documentar por turno o jornada",
    turnos: "Cuántos turnos haces a la semana?",
    reaccion: "Con tu formato y tu especialidad. Saquemos tu cuenta.",
  },
  no_medico: {
    donde: "Dónde trabajas",
    dondePh: "Ej: Kinesiología UCI, Hospital Barros Luco",
    carga: "Cuánto te toma escribir tus registros por turno",
    turnos: "Cuántos turnos haces a la semana?",
    reaccion: "También ordena tus registros del turno.",
  },
};

const BASE = {
  equipo: "En tu servicio, tienes internos o un backup que te ayude?",
  donde: "Dónde trabajas",
  dondePh: "Ej: Medicina interna, Hospital Sótero del Río",
  carga: "Cuánto te toma documentar por turno",
  turnos: "Cuántos turnos haces a la semana?",
  reaccion: "",
};

/** Los textos de Quién eres para la etapa elegida (los de siempre si todavía no eligió). */
export const textosDeEtapa = (etapa) => ({ ...BASE, ...(POR_ETAPA[etapa] || {}) });

/** Lo que responde la tarjeta a «cuánto te toma documentar». */
export const reaccionCarga = (carga) =>
  ({
    "<1h": "Bien ahí. Igual sumado al año pesa.",
    "1-2h": "Una a dos horas por turno, todos los turnos.",
    "2-4h": "Hasta 4 horas: medio turno de 8 h, escribiendo.",
    "+4h": "Más de 4 horas. Esto es justo lo que vamos a atacar.",
  })[carga] || "";

/** Lo que responde la tarjeta a «cuántos turnos haces». `anual` = horas al año ya calculadas. */
export const reaccionTurnos = (turnos, anual) => {
  if (turnos === "0") return "Sin turnos también sirve: para tus días con hospitalizados.";
  if (turnos === "4+" && anual >= 1000) return "Más de 1.000 horas al año. Eso es un trabajo aparte.";
  if (turnos === "4+") return "4 o más turnos a la semana: es mucho tiempo escribiendo.";
  return "";
};

/** Lo que responde la tarjeta a «con quién trabajas». */
export const reaccionEquipo = (equipo) => {
  const e = Array.isArray(equipo) ? equipo : [];
  if (e.includes("nadie")) return "Sin apoyo en el turno: que nada se te quede en la cabeza.";
  if (e.includes("internos") || e.includes("becados")) return "Con equipo, la entrega tiene que quedar clara para todos.";
  if (e.includes("backup")) return "Con backup: lo que anotas le sirve también a quien te cubre.";
  return "";
};
